import React from 'react'
import Image from '../../../common/footer/Images/Image'
import StencilBox from '../../stencils/StencilBox'

function AboutAuthorStencil({ classes }) {
    return (
        <div>
            <div class={`edu-blog-widget bg-white widget-about ${classes ? classes : ""}`}>
                <div class="inner">
                    <h5 className="placeholder-glow mb--30">
                        <span className="placeholder w-50 bg-smoke"></span>
                    </h5>
                    <div class="content">
                        <div class="about-wrapper">
                            <div class="">
                                <Image src="#" alt="Thumbnail" fill />
                            </div>
                            <div class="about-content">
                                <h6 className="placeholder-glow mb--o mt--10">
                                    <span className="placeholder w-100 bg-smoke"></span>
                                </h6>
                                <p>
                                    <StencilBox
                                        className="bg-smoke"
                                        width="100%"
                                        height="100px"
                                        backgroundColor="#F5F5F5"
                                    />
                                </p>
                                <div className="social-share bg-transparent medium-size w-100 d-flex gap-3 justify-content-center align-items-center">
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutAuthorStencil
